import { render, staticRenderFns } from "./LoginLegacy.vue?vue&type=template&id=2f27248e&scoped=true&"
import script from "./LoginLegacy.vue?vue&type=script&lang=js&"
export * from "./LoginLegacy.vue?vue&type=script&lang=js&"
import style0 from "./LoginLegacy.vue?vue&type=style&index=0&id=2f27248e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f27248e",
  null
  
)

export default component.exports